// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../../../components/library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.si81GjFpxr9F7tS0HNm2 {
    background-color: #F7F7F7;
    width: 100%;
    height: calc(100vh - 70px);
    padding: 16px;
    box-sizing: border-box;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.xNQ4TMliqpW_f_rJuFd7 {
    width: 30%;
    opacity: 20% !important;
}

.si81GjFpxr9F7tS0HNm2 h1 {
    font-size: 24px;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
    margin-top: 32px;
    margin-bottom: 8px;
}

.uzs771A9MzNUP1ZyWJl7 {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
    margin-top: 8px;
    max-width: 525px;
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/DashboardError/DashboardError.module.css"],"names":[],"mappings":"AAGA;IACI,yBAAyB;IACzB,WAAW;IACX,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;;IAEtB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,mDAAwB;IACxB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mDAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB","sourcesContent":["@value colors: \"../../../components/library/style/colors.css\";\n@value color-text-subtle from colors;\n\n.background {\n    background-color: #F7F7F7;\n    width: 100%;\n    height: calc(100vh - 70px);\n    padding: 16px;\n    box-sizing: border-box;\n\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.imgIllustration {\n    width: 30%;\n    opacity: 20% !important;\n}\n\n.background h1 {\n    font-size: 24px;\n    color: color-text-subtle;\n    margin-top: 32px;\n    margin-bottom: 8px;\n}\n\n.description {\n    color: color-text-subtle;\n    margin-top: 8px;\n    max-width: 525px;\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../../../components/library/style/colors.css"`,
	"color-text-subtle": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]}`,
	"background": `si81GjFpxr9F7tS0HNm2`,
	"imgIllustration": `xNQ4TMliqpW_f_rJuFd7`,
	"description": `uzs771A9MzNUP1ZyWJl7`
};
export default ___CSS_LOADER_EXPORT___;
